import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ArtistCard } from '../ArtistCard';
import { fetchArtists } from '../../lib/api';
import { useSettings } from '../../lib/useSettings';

export const FeaturedArtists = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const { settings, ready } = useSettings();

  useEffect(() => {
    if (!ready) return;
    fetchArtists({ limit: 60 })
      .then(arr => {
        const order = Array.isArray(settings.featured_artist_slugs) ? settings.featured_artist_slugs : [];
        let picked;
        if (order.length > 0) {
          // Admin-curated: exact slugs in exact order (only existing/published ones)
          const bySlug = Object.fromEntries(arr.map(a => [a.slug, a]));
          picked = order.map(s => bySlug[s]).filter(Boolean).slice(0, 6);
        } else {
          // Fallback: artists flagged `featured` (in DB order), else first 6 published
          const featured = arr.filter(a => a.featured);
          picked = (featured.length >= 3 ? featured : arr).slice(0, 6);
        }
        setArtists(picked);
      })
      .finally(() => setLoading(false));
  }, [ready, settings.featured_artist_slugs]);

  return (
    <section className="bg-white py-24 md:py-32" data-testid="featured-artists-section">
      <div className="container-edge">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">The Edit · {new Date().getFullYear()}</div>
            <h2 className="mt-3 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Featured <span className="italic text-[#a465a8]">artists</span> — verified, trusted, in demand.
            </h2>
          </div>
          <Link
            to="/artists"
            data-testid="view-all-artists-link"
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] hover:text-[#eb5381] self-start md:self-auto"
          >
            View All Artists <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[0, 1, 2, 3, 4, 5].map(i => (
              <div key={i} className="aspect-[4/5] bg-[#f7f7f7] animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {artists.map(a => <ArtistCard key={a.slug} artist={a} />)}
          </div>
        )}
      </div>
    </section>
  );
};
